import { Auth } from '@nackle/bridge'; 
import { authService } from './authService';
import umbrella from '@nackle/umbrella';

const getEnv = () => {
    const host = window.location.hostname.toLowerCase();

    if ( host.includes( 'localhost' ) || host.includes( 'qa.' ) ) {
        return 'qa.';
    }
    
    if ( host.includes( 'pprd.' ) ) {
        return 'pprd.';
    }
    
    return '';
};
 
const AUTH_ENDPOINT = `https://${ getEnv() }api.biw.cloud/v1/id`; 
export const ROSTER_GROUPS_HATCH = `https://${ getEnv() }roster-groups.biw.cloud`; 

export const canShowBIWAdminStuff = () => { 
    const biwAdminURLS = [
        'localhost', // Comment this line to hide the company chooser stuff on localhost
        'qa.courses.biw.cloud',
        'pprd.courses.biw.cloud',
        'courses.biw.cloud'
    ];

    return biwAdminURLS.includes( window.location.hostname.toLocaleLowerCase() );
};

const getExtraQueryParams = () => {
    const host = window.location.hostname.toLowerCase();

    const hoyaHosts = [ 
        //'localhost',
        'hoya.qa.courses.biw.cloud',
        'hoya.pprd.courses.biw.cloud',
        'hoya.courses.biw.cloud'
    ];

    if ( hoyaHosts.includes( host ) ) {
        const extra = {
            settings: 'SAML2:3833e8f6-867e-4807-ae6a-07c8037b8b59',
            directAccess: false
        };

        return extra;
    } else {
        return {};
    }
};

const auth = 
    window.location.hostname.toLowerCase().includes( 'localhost' ) ? 
        umbrella.getAuth( true, 60, 59, { 
            authority: AUTH_ENDPOINT, 
            debug: false,
            automaticSilentRenew: true,
            companyId: '2eddede7-12e0-493a-ba36-3940b96b1cac' //eslint-disable-line
        } )
        :
        new Auth( {
            authority: AUTH_ENDPOINT,
            debug: false,
            automaticSilentRenew: true,
            extraQueryParams: getExtraQueryParams()
        } );

authService.setAuthController( auth );
 
export default auth;
